import { render } from "./ScormPlayer.vue?vue&type=template&id=5c856500&scoped=true"
import script from "./ScormPlayer.vue?vue&type=script&lang=js"
export * from "./ScormPlayer.vue?vue&type=script&lang=js"

import "./ScormPlayer.vue?vue&type=style&index=0&id=5c856500&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c856500"]])

export default __exports__